module.exports = {
	"id": "US",
	"name": "United States of America",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.005808,
			"11": 0.017424,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.011616,
			"19": null,
			"20": null,
			"21": 0.011616,
			"22": 0.005808,
			"23": 0.011616,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.005808,
			"28": null,
			"29": 0.017424,
			"30": null,
			"31": 0.034848,
			"32": 0.011616,
			"33": 0.017424,
			"34": 0.02904,
			"35": 0.017424,
			"36": 0.023232,
			"37": 0.034848,
			"38": 0.040656,
			"39": 0.046464,
			"40": 0.063888,
			"41": 0.092928,
			"42": 0.05808,
			"43": 0.278784,
			"44": 0.121968,
			"45": 0.08712,
			"46": 0.075504,
			"47": 0.075504,
			"48": 0.243936,
			"49": 1.208064,
			"50": 0.243936,
			"51": 0.818928,
			"52": 1.057056,
			"53": 19.973712,
			"54": 4.716096,
			"55": 0.052272,
			"56": 0.040656,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.017424,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011616,
			"12": 0.005808,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.011616,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.005808,
			"22": null,
			"23": null,
			"24": 0.011616,
			"25": 0.005808,
			"26": null,
			"27": 0.005808,
			"28": 0.017424,
			"29": 0.011616,
			"30": 0.005808,
			"31": 0.034848,
			"32": 0.005808,
			"33": 0.017424,
			"34": 0.011616,
			"35": 0.023232,
			"36": 0.023232,
			"37": 0.017424,
			"38": 0.092928,
			"39": 0.081312,
			"40": 0.075504,
			"41": 0.081312,
			"42": 0.075504,
			"43": 0.1452,
			"44": 0.05808,
			"45": 0.249744,
			"46": 0.133584,
			"47": 0.46464,
			"48": 0.569184,
			"49": 5.076192,
			"50": 0.046464,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.017424
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.011616,
			"37": 0.017424,
			"38": 0.069696,
			"39": 0.017424,
			"40": 0.139392,
			"41": 0.023232,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.023232
		},
		"safari": {
			"0": null,
			"4": 0.02904,
			"5": 0.05808,
			"6": 0.017424,
			"7": 0.069696,
			"8": 0.26136,
			"9": 0.365904,
			"10": 2.29416,
			"3.1": null,
			"3.2": null,
			"5.1": 0.151008,
			"6.1": 0.17424,
			"7.1": 0.046464,
			"9.1": 2.270928
		},
		"ios_saf": {
			"8": 0,
			"10": 15.1019156037,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.406979150708,
			"8.1-8.4": 0.751876736053,
			"9.0-9.2": 0.358693488759,
			"9.3": 5.47237502082
		},
		"android": {
			"3": 0,
			"4": 0.0146340878553,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00182926098191,
			"4.1": 0.052787245478,
			"4.2-4.3": 0.131968113695,
			"4.4": 0.302612031008,
			"4.4.3-4.4.4": 0.305225260982
		},
		"ie": {
			"6": 0.0470015012853,
			"7": 0.052876688946,
			"8": 0.387762385604,
			"9": 0.364261634961,
			"10": 0.405387948586,
			"11": 7.8727514653,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0101181993087,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000281061091909
		},
		"edge": {
			"12": 0.081312,
			"13": 0.511104,
			"14": 2.421936
		},
		"ie_mob": {
			"10": 0.0487689014085,
			"11": 0.198559098592
		},
		"bb": {
			"7": 0.014672,
			"10": null
		},
		"samsung": {
			"0": 3.114656
		},
		"and_uc": {
			"0": 0.48208
		},
		"op_mini": {
			"0": 0.136320739599
		},
		"and_chr": {
			"0": 16.667984
		},
		"and_ff": {
			"0": 0.058688
		}
	},
	"total": 98.7798496247
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/US.json
 ** module id = 672
 ** module chunks = 0
 **/